const de = require('./de.json')

const messages = { de }
const defaultLang = 'de'

module.exports = {
  messages,
  defaultLang,
}
